import createAPI from '../axios'

// 客户管理 API
const custom = {
    info: {
        list: config => createAPI('/custom/list', 'post', config),
        mapTest: config => createAPI('/custom/mapTest', 'post', config),
    },
    restful:{
        auth:config => createAPI('/restfulAuth', 'post', config),
        test:config => createAPI('/restfulTest', 'post', config),
    }
};

export default custom;



// WEBPACK FOOTER //
// ./src/api/modules/custom.js